import React from 'react';
import { Button } from '@emorg-prd/react-standard';
import './index.css';

import RealEstateInterestAPI from '../../../../api/RealEstateInterest';
import RealEstateInterestType from '../../../../api/RealEstateInterestType';
import RealEstateInterestItem from './ReiItem';
function RealEstateInterestWrapper(props) {
  const {
    onChange,
    handlePageError,
    realEstateInterestList,
    realEstateInterestDropdown,
    locationStateLocationId,
  } = props;
  const descMax = 250;

  const populateREITypeahead = (index, value) => {
    const dropdown = [...realEstateInterestDropdown];
    RealEstateInterestAPI.getBySearchText(value).then((res) => {
      dropdown[parseInt(index)] = res;
      onChange('realEstateInterestDropdown', dropdown);
    }).catch((error) => {
      handlePageError(error.message);
    });
  };

  const handleInterestChange = async (fieldName, index, event, value, REIObject = null) => {
    if (event !== null) {
      event.preventDefault();
    }

    let reiListCopy = [...realEstateInterestList];
    let reiListObj = reiListCopy[parseInt(index)];

    if (REIObject === null) {
      switch (fieldName) {
        case 'name':
          reiListCopy[parseInt(index)].realEstateInterestName = value;
          if (value.length > 2 && !reiListObj.isNew) {
            populateREITypeahead(index, value);
          }
          break;
        case 'type':
          reiListObj.realEstateInterestTypeName = event.target.value;
          reiListObj.realEstateInterestTypeId =
            event.target.options[event.target.selectedIndex].id;
          break;
        case 'primary':
          reiListCopy.map((interest) => {
            interest.primary = false;
            return interest;
          });
          reiListObj.primary = true;
          break;
        case 'realEstateInterestDesc':
          if (event.target.value.length <= descMax) {
            reiListObj.realEstateInterestDesc = event.target.value;
          }
          break;
        case 'realEstateInterestSizeUOM':
          reiListObj.realEstateInterestSizeUOM = event.target.value;
          break;
        case 'realEstateInterestArea':
          reiListObj.realEstateInterestArea = event.target.value;
          break;
        default:
          alert('error');
      }
    } else {
      clearREIValues(index);
      reiListObj.realEstateInterestName = REIObject.realEstateInterestName;
      reiListObj.locationId = REIObject.locationId;
      reiListObj.primary = false;
      reiListObj.realEstateInterestDesc = REIObject.realEstateInterestDesc;
      reiListObj.realEstateInterestId = REIObject.realEstateInterestId;
      reiListObj.realEstateInterestArea = REIObject.realEstateInterestArea
        ? REIObject.realEstateInterestArea
        : '';
      reiListObj.realEstateInterestSizeUOM = REIObject.realEstateInterestSizeUOM
        ? REIObject.realEstateInterestSizeUOM
        : '';
      reiListObj.realEstateInterestSourceSystemRelate =
        REIObject.realEstateInterestSourceSystemRelateData.length > 0
          ? REIObject.realEstateInterestSourceSystemRelateData.map((source) => ({
            reiSourceSystemRelateId: source.reiSourceSystemRelateId,
            realEstateInterestId: source.realEstateInterestId,
            realEstateInterestSourceSystemId: source.sourceSystemId,
            realEstateInterestSourceSystemName: source.sourceSystem?.sourceSystemName,
            realEstateInterestSourceSystemTypeId: source.sourceSystemIdTypeId,
            realEstateInterestSourceSystemIdTypeName:
              source.sourceSystemIdType?.sourceSystemIdTypeName,
            realEstateInterestSourceSystemReferenceID: source.sourceSystemReferenceId,
          }))
          : REIObject.realEstateInterestSourceSystemRelateData;
      reiListObj.isREILocked = REIObject.isPrimaryRealEstateInterest;
      let primaryREI = reiListCopy.find((interest) => interest.primary);
      if (!primaryREI) {
        reiListObj.primary = true;
      }
      reiListObj.realEstateInterestTypeId = REIObject.realEstateInterestTypeId;
      let reiInterestType = await RealEstateInterestType.get(
        REIObject.realEstateInterestTypeId
      );
      reiListObj.realEstateInterestTypeName = reiInterestType.realEstateInterestTypeName;

      onChange('realEstateInterestList', reiListCopy);
    }

    onChange('realEstateInterestList', reiListCopy);
  };

  const addREIField = () => {
    let values = [...realEstateInterestList];
    let dropdown = [...realEstateInterestDropdown];
    values.push({
      isNew: true,
      realEstateInterestName: '',
      realEstateInterestTypeId: '',
      primary: false,
      realEstateInterestDesc: '',
      realEstateInterestArea: '',
      realEstateInterestSizeUOM: '',
      realEstateInterestSourceSystemRelate: [],
      locationId: '',
    });
    dropdown.push([]);
    onChange('realEstateInterestDropdown', dropdown);
    onChange('realEstateInterestList', values);
  };

  const removeREIField = (index) => {
    let reiListCopy = [...realEstateInterestList];
    let dropdown = [...realEstateInterestDropdown];
    if (reiListCopy.length > 1) {
      if (reiListCopy[parseInt(index)].primary) {
        if (index !== 0) {
          handleInterestChange('primary', 0, null, null);
        } else {
          handleInterestChange('primary', 1, null, null);
        }
      }
      reiListCopy.splice(index, 1);
      dropdown.splice(index, 1);
      onChange('realEstateInterestDropdown', dropdown);
      onChange('realEstateInterestList', reiListCopy);
    } else {
      alert('Location must have one Real Estate Interest.');
    }
  };

  const addRealEstateInterestSourceSystem = (index) => {
    let reiListCopy = [...realEstateInterestList];
    reiListCopy[parseInt(index)].realEstateInterestSourceSystemRelate.push({
      realEstateInterestSourceSystemId: '',
      realEstateInterestSourceSystemName: '',
      realEstateInterestSourceSystemIdTypeName: '',
      realEstateInterestSourceSystemTypeId: '',
      realEstateInterestSourceSystemReferenceID: '',
    });
    onChange('realEstateInterestList', reiListCopy);
  };

  const deleteRealEstateInterestSourceSystem = (sourceSystemIndex, reiIndex) => {
    let reiListCopy = [...realEstateInterestList];
    reiListCopy[parseInt(reiIndex)].realEstateInterestSourceSystemRelate.splice(
      sourceSystemIndex, 1
    );
    onChange('realEstateInterestList', reiListCopy);
  };

  const handleRealEstateInterestSourceSystemChange = (
    fieldName, sourceSystemIndex, reiIndex, event
  ) => {
    let reiListCopy = [...realEstateInterestList];
    let reiSourceSystemObject =
      reiListCopy[parseInt(reiIndex)].realEstateInterestSourceSystemRelate[
        parseInt(sourceSystemIndex)
      ];
    switch (fieldName) {
      case 'sourceSystemName':
        reiSourceSystemObject.realEstateInterestSourceSystemId =
          event.target.options[event.target.selectedIndex].id;
        reiSourceSystemObject.realEstateInterestSourceSystemName = event.target.value;
        break;
      case 'sourceSystemIdTypeName':
        reiSourceSystemObject.realEstateInterestSourceSystemTypeId =
          event.target.options[event.target.selectedIndex].id;
        reiSourceSystemObject.realEstateInterestSourceSystemIdTypeName = event.target.value;
        break;
      case 'sourceSystemID':
        reiSourceSystemObject.realEstateInterestSourceSystemReferenceID =
          event.target.value;
        break;
      default:
        alert('error');
    }
    onChange('realEstateInterestList', reiListCopy);
  };
  const handleREIToggle = (event, value, index) => {
    event.preventDefault();
    let reiListCopy = [...realEstateInterestList];
    reiListCopy[parseInt(index)].isNew = value;
    onChange('realEstateInterestList', reiListCopy);
    clearREIValues(index);
  };
  const clearREIValues = (index) => {
    if (index !== undefined) {
      let reiListCopy = [...realEstateInterestList];
      let reiObject = reiListCopy[parseInt(index)];
      reiObject.realEstateInterestName = '';
      reiObject.realEstateInterestTypeId = '';
      reiObject.realEstateInterestTypeName = '';
      reiObject.realEstateInterestDesc = '';
      reiObject.realEstateInterestSourceSystemRelate.splice(
        0, reiObject.realEstateInterestSourceSystemRelate.length
      );
      reiObject.isREILocked = false;
      //Advanced Options
      reiObject.realEstateInterestSizeUOM = '';
      reiObject.realEstateInterestArea = '';
      onChange('realEstateInterestList', reiListCopy);
    }
  };

  //TODO: ADD REGEX to appropriate area
  // let regx = /^[1-9][0-9]*(\.\d{0,2})?$|^100$/;
  // if (fieldName !== 'realEstateInterestBusinessLineAlias' && !regx.test(value)) {
  //   alert('Only numbers and decimals are allowed');

  return (
    <div>
      {realEstateInterestList.map((realEstateInterest, index) => (
        <RealEstateInterestItem
          key={index}
          index={index}
          realEstateInterest={realEstateInterest}
          handleREIToggle={handleREIToggle}
          removeREIField={removeREIField}
          handleInterestChange={handleInterestChange}
          realEstateInterestDropdown={realEstateInterestDropdown}
          handleRealEstateInterestSourceSystemChange={
            handleRealEstateInterestSourceSystemChange
          }
          addRealEstateInterestSourceSystem={addRealEstateInterestSourceSystem}
          deleteRealEstateInterestSourceSystem={deleteRealEstateInterestSourceSystem}
          onChange={onChange}
          handlePageError={handlePageError}
          locationStateLocationId={locationStateLocationId}
        />
      ))}
      <Button
        className='small-margin'
        variant='tertiary'
        size='small'
        style={{ paddingTop: '20px', marginTop: '0px', paddingBottom: '40px' }}
        onClick={addREIField}
      >
        + Add Real Estate Interest
      </Button>
    </div>
  );
}

export default RealEstateInterestWrapper;
